<template>
  <div>
    <GoBackView />
    <WebHeaderView />
    <ShopHeaderView />
    <ShopProductView />
    </div>
</template>

<script>
import WebHeaderView from '@/components/header/index.vue'
import GoBackView from '@/components/goback/index.vue'
import { ShopHeaderView ,ShopProductView} from './components/index'
export default {
  name: 'ShopView',
  components: { WebHeaderView,ShopHeaderView,ShopProductView,GoBackView },

}
</script>

<style>

</style>
